import * as React from 'react';
import { Button, TextField } from '../common';
import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';
import { Grid2 as Grid } from '@mui/material';

interface Props extends BaseDialogProps {
    readonly onCreate: (key: string, english: string, spanishMexican: string, spanishSpain: string, deutsch: string, french: string, italian: string, portugueseBrazil: string) => void;
}

interface State extends BaseDialogState {
    key: string;
    english: string;
    spanishMexican: string;
    spanishSpain: string;
    deutsch: string;
    french: string;
    italian: string;
    portugueseBrazil: string;
}

export class CreateLocalizationDialog extends BaseDialog<Props, State> {
    state = this.initState();

    protected renderContent(): React.JSX.Element {
        const { key, english, spanishMexican, spanishSpain, deutsch, french, italian, portugueseBrazil } = this.state;
        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label="Key"
                        fullWidth={true}
                        value={key}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateKey}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="English"
                        fullWidth={true}
                        value={english}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateEnglish}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Mexican Spanish"
                        fullWidth={true}
                        value={spanishMexican}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateSpanishMexican}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Spain Spanish"
                        fullWidth={true}
                        value={spanishSpain}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateSpanishSpain}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Deutsch"
                        fullWidth={true}
                        value={deutsch}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateDeutsch}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Italian"
                        fullWidth={true}
                        value={italian}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateItalian}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="French"
                        fullWidth={true}
                        value={french}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdateFrench}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Brazil Portuguese"
                        fullWidth={true}
                        value={portugueseBrazil}
                        variant="outlined"
                        required={true}
                        onChange={this.onUpdatePortugueseBrazil}
                        disabled={false}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Create" onClick={this.onSubmit} variant="contained" disabled={!this.validate()}/>
        );
    }

    protected initState(): State {
        return {
            key: '',
            english: '',
            spanishMexican: '',
            spanishSpain: '',
            deutsch: '',
            french: '',
            italian: '',
            portugueseBrazil: '',
        };
    }

    private validate(): boolean {
        const { key } = this.state;
        if (!key || key === '') {
            return false;
        }
        return true;
    }

    private onUpdateKey = (key: string) => this.setState({ key });

    private onUpdateEnglish = (english: string) => this.setState({ english });

    private onUpdateSpanishMexican = (spanishMexican: string) => this.setState({ spanishMexican });

    private onUpdateSpanishSpain = (spanishSpain: string) => this.setState({ spanishSpain });

    private onUpdateDeutsch = (deutsch: string) => this.setState({ deutsch });

    private onUpdateFrench = (french: string) => this.setState({ french });

    private onUpdateItalian = (italian: string) => this.setState({ italian });

    private onUpdatePortugueseBrazil = (portugueseBrazil: string) => this.setState({ portugueseBrazil });

    private onSubmit = () => {
        const { key, english, spanishMexican, spanishSpain, deutsch, french, italian, portugueseBrazil } = this.state;

        this.props.onCreate(key, english, spanishMexican, spanishSpain, deutsch, french, italian, portugueseBrazil);
        this.onClose();
    };
}
